export const UserRole = {
  MEMBER: "member",
  FACILITATOR: "facilitator",
  ADMIN: "admin",
  STAFF: "staff",
} as const;

export type UserRoleType = (typeof UserRole)[keyof typeof UserRole];

export const AppContext = {
  BRIDGE: "bridge",
  PULSE: "pulse",
  CIRCLE: "circle",
  HABITAT: "habitat",
  BILLING: "billing",
  FINDER: "finder",
  REGISTER: "register",
} as const;

export type AppContextType = (typeof AppContext)[keyof typeof AppContext];

export const OrganizationType = {
  CHURCH: "church",
  FACILITY: "facility",
  GROUP: "group",
} as const;

export type OrganizationTypeType =
  (typeof OrganizationType)[keyof typeof OrganizationType];
